import { formatCurrency } from "./currencyUtils";
export const selectedProduct = (product, optionId) => {
  if (!product.priceOptions?.length) return product;
  const option = product.priceOptions.find((o) => o.id === optionId);
  if (!option) return null;
  return {
    ...product,
    name: `${product.name} — ${option.label}`,
    price: option.price,
    selectedOptionId: option.id,
    selectedOptionLabel: option.label,
  };
};
export const productPrice = (product, currency = "NGN") => {
  const prices =
    product.priceOptions?.length && !product.selectedOptionId
      ? product.priceOptions.map((o) => o.price)
      : [product.price];
  const net = prices.map(
    (value) => value - Math.floor((value * (product.discount || 0)) / 100),
  );
  const min = Math.min(...net),
    max = Math.max(...net);
  const format = (value) => formatCurrency(value, currency, product.currency);
  return min === max ? format(min) : `${format(min)} – ${format(max)}`;
};

export const quoteProducts = products => products.map(group => ({ products: group.products.map(row => ({ productInfo: { _id: row.productInfo._id }, quantity: row.quantity, optionId: row.optionId || row.productInfo.selectedOptionId || '' })) }));
